import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  getElementsById,
  getElementsEventDataById,
} from "core-integration/src/store/elements/reducers";
import { fetchEventLive } from "core-integration/src/store/elements/thunks";
import {
  getEntry,
  getEntryEventFormation,
  getEntryEventPicks,
  getEntryEventPoints,
} from "core-integration/src/store/entries/reducers";
import {
  fetchEntryEventPicks,
  fetchEntrySummary,
} from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import {
  getCurrentEvent,
  getEventsById,
} from "core-integration/src/store/events/reducers";
import { getFixturesForEventById } from "core-integration/src/store/fixtures/reducers";
import { fetchFixtures } from "core-integration/src/store/fixtures/thunks";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { IPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import range from "lodash/range";
import { hideVisually, size } from "polished";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink, useParams } from "react-router";
import { Box } from "rebass/styled-components";
import styled, { css } from "styled-components";
import BaseDreamTeam from "../../img/icons/dreamteam.svg?react";
import BaseReload from "../../img/icons/reload.svg?react";
import { ChipName, getChipName } from "../../utils/chips";
import ButtonLink from "../ButtonLink";
import Entry from "../Entry";
import Fixtures from "../Fixtures";
import { ControlArrowLeft, ControlArrowRight } from "../icons/Arrows";
import DreamTeam from "../icons/DreamTeam";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import PageAd, { PageAdWrap } from "../PageAd";
import {
  EventPager,
  PagerButton,
  PagerButtonNext,
  PagerHeading,
} from "../Pager";
import Panel from "../Panel";
import { ElementRow } from "../Pitch";
import { NotFound } from "../Routes";
import Table, { THeadRadius } from "../Table";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import Title from "../Title";
import Bench from "./Bench";
import BenchUnit from "./BenchUnit";
import ElementExplainDialog from "./ElementExplainDialog";
import EntryEventTable from "./EntryEventTable";
import PitchFormation from "./PitchFormation";
import valueForPlayerElement from "./valueForPlayedElement";

const StyledPitchWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
  }
`;

const PointsScoreboard = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    position: relative;
    align-items: flex-start;
    padding-bottom: 4rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${({ theme }) => theme.radii[2]};
  }
`;

const ScoreboardPrimary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-basis: 25%;
  }
`;

interface IPrimaryPanelProps {
  chipPlayed?: boolean;
}

const PrimaryPanel = styled.div<IPrimaryPanelProps>`
  padding-top: 4rem;
  padding-right: ${({ theme }) => theme.space[2]};
  padding-bottom: 4.3rem;
  padding-left: ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radii[2]};
  background-color: ${({ theme }) => theme.colors.blueDarker3};
  text-align: center;

  ${(props) =>
    props.chipPlayed &&
    css`
      padding-top: 2rem;
      padding-bottom: 1.8rem;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: 1.2rem 0;
  }
`;

const PrimaryHeading = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes[4]};
  margin: ${({ theme }) => theme.space[2]} 0;
`;

const PrimaryValue = styled.div`
  position: relative;
  font-size: 4rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-bottom: 0.3rem;
  }
`;

const ReloadButton = styled.button`
  position: absolute;
  top: 50%;
  left: -${({ theme }) => theme.space[2]};
  transform: translateY(-50%);
  padding: ${({ theme }) => theme.space[1]};
  border: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  line-height: 1;
  cursor: pointer;
`;

const Reload = styled(BaseReload)`
  fill: white;
`;

const ReloadButtonText = styled.span`
  ${hideVisually()}
`;

const ScoreboardSecondary = styled.div`
  flex: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    display: flex;
    align-items: flex-start;
    flex-basis: 75%;
  }
`;

const SecondaryPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.primary};
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space[2]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 1;

    &:not(:last-child) {
      margin-right: ${({ theme }) => theme.space[2]};
    }
  }
`;

const SecondaryItem = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.radii[2]};
  background-color: ${({ theme }) => theme.colors.blueDarker3};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
  }
`;

const SecondaryHeading = styled.h4`
  flex: 1 0 60%;
  margin-top: 1.7rem;
  padding-left: ${({ theme }) => theme.space[2]};
  margin-bottom: 1.7rem;
`;

const SecondaryValue = styled.div`
  flex: 1 0 40%;
  margin-top: 1.7rem;
  margin-bottom: 1.7rem;
  padding-right: ${({ theme }) => theme.space[2]};
  font-weight: bold;
  text-align: right;
`;

const DreamTeamLinkIcon = styled(BaseDreamTeam)`
  ${size(16)}
  margin-right: ${({ theme }) => theme.space[1]};
  color: white;
  fill: #005baa;
`;

const DreamTeamLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: ${({ theme }) => theme.borders[0]};
  border-radius: ${({ theme }) => theme.radii[1]};
  padding: 0.8rem;
  background-color: white;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    position: absolute;
    right: ${({ theme }) => theme.space[2]};
    bottom: ${({ theme }) => theme.space[2]};
  }
`;

const ChipStatus = styled.div`
  margin-top: ${({ theme }) => theme.space[1]};
  padding: ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radii[2]};
  background-color: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: bold;
  text-align: center;
`;

type Props = WithTranslation;

const EntryEvent = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const params = useParams();
  const [pickForMenu, setPickForMenu] = useState<IPickLight | null>(null);

  const entryId = Number(params.entryId);
  const eventId = Number(params.eventId);
  const player = useSelector(getPlayerData) as IPlayer;

  const elementsById = useSelector(getElementsById);
  const elementsDataById = useSelector((state: RootState) =>
    getElementsEventDataById(state, eventId),
  );
  const entry = useSelector((state: RootState) => getEntry(state, entryId));
  const event = useSelector(
    (state: RootState) => getEventsById(state)[eventId],
  );
  const now = useSelector(getCurrentEvent);
  const entryData = useSelector((state: RootState) =>
    getEntryEventPicks(state, entryId, eventId),
  );
  const fixturesById = useSelector((state: RootState) =>
    getFixturesForEventById(state, eventId),
  );
  const formation = useSelector((state: RootState) =>
    getEntryEventFormation(state, entryId, eventId),
  );
  const points = useSelector((state: RootState) =>
    getEntryEventPoints(state, entryId, eventId),
  );
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);
  const mine = useSelector(() =>
    Boolean(player && player.entry && player.entry === entryId),
  );

  const handleShowMenuForPickElement = (element: number) => {
    const matches = entryData!.picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsDataById &&
    elementsDataById[pick.element] &&
    elementsDataById[pick.element].stats.in_dreamteam ? (
      <Link to={`/dream-team/${event!.id}`}>
        <DreamTeam />
      </Link>
    ) : null;

  const fetchDataAndFixtures = () => {
    fetchData();
    dispatch(fetchFixtures(Number(eventId)));
  };

  const fetchData = useCallback(() => {
    dispatch(fetchEntrySummary(Number(entryId)));
    dispatch(fetchEntryEventPicks(Number(entryId), Number(eventId)));
    dispatch(fetchEventLive(Number(eventId)));
  }, [dispatch, entryId, eventId]);

  useEffect(() => {
    fetchData();
  }, [entryId, eventId, fetchData]);

  // Handle unknown and unstarted events
  if (!now || !event || event.id > now.id) {
    return <NotFound />;
  }
  if (!entry || !entryData) {
    return null;
  }

  const chipName = entryData.active_chip
    ? getChipName(entryData.active_chip as ChipName, t)
    : "";

  // Create a new function on each render as data could have changed and
  // need to ensure a render of connected subcomponents
  const renderPickValue = valueForPlayerElement({
    elementsById,
    elementsDataById,
    fixturesById,
    teamsById,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    11: (
      <abbr title={t<string>("entryEvent.goalkeeper.title", "Goalkeeper")}>
        {t("entryEvent.goalkeeper.abbr", "GK")}
      </abbr>
    ),
    12: "1",
    13: "2",
    14: "3",
  };

  // Handle events before the entry started
  return (
    <Wrapper>
      <Main>
        <Box mx={2}>
          <Title>
            {t("entryEvent.title", "Points")} - {entry.name}
          </Title>
        </Box>
        {/* ROUND PAGER */}
        <Box mb={4}>
          <Box mx={2}>
            <PagerHeading>{event.name}</PagerHeading>
          </Box>
          {(event.id > entry.started_event || event.id < now.id) && (
            <EventPager>
              {event.id > entry.started_event && (
                <PagerButton>
                  <ButtonLink
                    to={`/entry/${entry.id}/event/${event.id - 1}`}
                    variant="primary"
                  >
                    <ControlArrowLeft />
                    {t("entryEvent.prev", "Previous")}
                  </ButtonLink>
                </PagerButton>
              )}
              {event.id < now.id && (
                <PagerButtonNext>
                  <ButtonLink
                    to={`/entry/${entry.id}/event/${event.id + 1}`}
                    variant="primary"
                  >
                    {t("entryEvent.next", "Next")}
                    <ControlArrowRight />
                  </ButtonLink>
                </PagerButtonNext>
              )}
              {/* Also need to check isn't last event */}
              {mine && event.id === now.id && (
                <PagerButtonNext>
                  <ButtonLink to={`/my-team`} variant="primary">
                    {t("entryEvent.next", "Next")}
                    <ControlArrowRight />
                  </ButtonLink>
                </PagerButtonNext>
              )}
            </EventPager>
          )}
        </Box>
        {/* SCOREBOARD */}
        <Box mb={4}>
          <PointsScoreboard>
            <ScoreboardPrimary>
              <Box mb={2}>
                <PrimaryPanel chipPlayed={Boolean(chipName)}>
                  <PrimaryHeading>
                    {event.finished
                      ? t("entryEvent.finalPoints", "Final Points")
                      : t("entryEvent.latestPoints", "Latest Points")}
                  </PrimaryHeading>
                  <PrimaryValue>
                    {points}
                    {!event.finished && (
                      <ReloadButton onClick={fetchDataAndFixtures}>
                        <ReloadButtonText>
                          {t("entryEvent.reload", "Reload Points")}
                        </ReloadButtonText>
                        <Reload />
                      </ReloadButton>
                    )}
                  </PrimaryValue>
                </PrimaryPanel>
                {chipName && (
                  <ChipStatus>
                    {t(
                      "entryEvent.ChipStatus.played",
                      "{{ chipName }} played",
                      {
                        chipName: chipName,
                      },
                    )}
                  </ChipStatus>
                )}
              </Box>
              <div>
                <DreamTeamLink to={`/dream-team/${event.id}`}>
                  <DreamTeamLinkIcon />
                  {t("entryEvent.dreamTeam", "Dream Team")}
                  <ControlArrowRight />
                </DreamTeamLink>
              </div>
            </ScoreboardPrimary>
            <ScoreboardSecondary>
              <SecondaryPanel>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.average", "Average Pts")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {event.average_entry_score || "-"}
                  </SecondaryValue>
                </SecondaryItem>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.highest", "Highest Pts")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {event.highest_scoring_entry ? (
                      <Link
                        to={`/entry/${event.highest_scoring_entry}/event/${event.id}`}
                      >
                        {event.highest_score || "???"}
                      </Link>
                    ) : (
                      "-"
                    )}
                  </SecondaryValue>
                </SecondaryItem>
              </SecondaryPanel>
              <SecondaryPanel>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.rank", "RD Rank")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {entryData.entry_history.rank
                      ? entryData.entry_history.rank.toLocaleString()
                      : "-"}
                  </SecondaryValue>
                </SecondaryItem>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.transfers", "Transfers")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    <Link to={`/entry/${entry.id}/transfers`}>
                      {entryData.entry_history.event_transfers}
                    </Link>{" "}
                    {entryData.entry_history.event_transfers_cost
                      ? `(-${entryData.entry_history.event_transfers_cost} pts)`
                      : ""}
                  </SecondaryValue>
                </SecondaryItem>
              </SecondaryPanel>
            </ScoreboardSecondary>
          </PointsScoreboard>
        </Box>
        <PageAdWrap>
          <PageAd />
        </PageAdWrap>
        {/* TEAM */}
        <StyledPitchWrapper>
          <Box pt={4}>
            <Box mx={2} mb={2}>
              <Tabs centered>
                <TabPanel
                  label={t("entryEvent.pitchView", "Pitch View")}
                  link="pitch"
                >
                  <Box mx={-2} pt={4}>
                    <PitchFormation
                      chipName={entryData.active_chip}
                      formation={formation}
                      picks={entryData.picks}
                      renderDreamTeam={renderDreamTeam}
                      renderElementMenu={handleShowMenuForPickElement}
                      renderPickValue={renderPickValue}
                    />
                    <Bench>
                      <ElementRow>
                        {range(
                          rules.squad_squadplay,
                          rules.squad_squadsize,
                        ).map((i) => (
                          <BenchUnit
                            key={i}
                            chipName={entryData.active_chip}
                            heading={benchHeading[i]}
                            pick={entryData.picks[i]}
                            renderDreamTeam={renderDreamTeam}
                            renderElementMenu={() =>
                              handleShowMenuForPickElement(
                                entryData.picks[i].element,
                              )
                            }
                            renderPickValue={renderPickValue}
                          />
                        ))}
                      </ElementRow>
                    </Bench>
                  </Box>
                </TabPanel>
                <TabPanel
                  label={t("entryEvent.listView", "List View")}
                  link="list"
                >
                  <Box my={4} bg="white">
                    <EntryEventTable
                      title={t("entryEvent.starters", "Starters")}
                      picks={entryData.picks.slice(0, rules.squad_squadplay)}
                      renderElementMenu={handleShowMenuForPickElement}
                      chipName={entryData.active_chip}
                      dataById={elementsDataById}
                    />
                    <EntryEventTable
                      title={t("entryEvent.substitutes", "Substitutes")}
                      picks={entryData.picks.slice(rules.squad_squadplay)}
                      renderElementMenu={handleShowMenuForPickElement}
                      chipName={entryData.active_chip}
                      dataById={elementsDataById}
                    />
                  </Box>
                </TabPanel>
              </Tabs>
            </Box>
          </Box>
        </StyledPitchWrapper>
        {entryData.automatic_subs.length > 0 && (
          <>
            <Box mx={2}>
              <Title>
                {t("entryEvent.autoSubs.title", "Automatic Substitutions")}
              </Title>
            </Box>
            <Panel>
              <THeadRadius>
                <Table>
                  <thead>
                    <tr>
                      <th>
                        {t("entryEvent.autoSubs.playerOut", "Player out")}
                      </th>
                      <th>{t("entryEvent.autoSubs.playerIn", "Player in")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entryData.automatic_subs.map((s) => (
                      <tr key={s.element_out}>
                        <td>{elementsById[s.element_out].web_name}</td>
                        <td>{elementsById[s.element_in].web_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </THeadRadius>
            </Panel>
          </>
        )}
        {pickForMenu && (
          <ElementExplainDialog
            elementId={pickForMenu.element}
            eventId={event.id}
            closeDialog={handleHideMenuForPick}
          />
        )}
        <Fixtures eventId={event.id} />
      </Main>
      <Secondary>
        <Entry entryId={entry.id} />
      </Secondary>
    </Wrapper>
  );
};

export default withTranslation()(EntryEvent);
